import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@wilson/config';
import { FilesService } from './files.service';
@NgModule({
  imports: [CommonModule, ConfigModule],
  providers: [FilesService],
})
export class FilesModule {}
